import {
  Backdrop,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState, useMemo, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
// import AccessLevel from "./AccessLevel";
import { createTheme } from "@mui/material/styles";
import { common_axios } from "../../../App";
import Loader from "../../../components/Loader";
import PersonIcon from "@mui/icons-material/Person";
import InfoIcon from "@mui/icons-material/Info";
import Swal from "sweetalert2";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
// import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import moment from "moment";

// import { TimePicker } from "@mui/lab";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers";

const BlackOut = () => {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });
  const [open, setOpen] = useState();
  const [value, setValue] = React.useState(new Date());
  const [valueEnd, setValueEnd] = React.useState(new Date());
  const [time, setTime] = React.useState();
  const [blackOutStarttime, setBlackOutStarttime] = React.useState();
  const [hideSkeleton1, setHideSkeleton1] = useState();

  // console.log("va--", blackOutStarttime);
  const handleChange = (event) => {
    setValue(event.target.value);
    const date1 = moment(value).format("HH:mm:ss");
  };
  // console.log("val", value);
  const date1 = moment(value).format("HH:mm:ss");

  // console.log("ths", date1);
  //  .................................BlackOut Get API..................................................//

  async function BlackOutGet() {
    // setData([])
    setHideSkeleton1(true);

    try {
      // setOpen(true);

      const result = await common_axios.get(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/black-out`
      );

      // console.log("result get api.........", result);

      if (result.data.statusDescription.statusCode == 200) {
        setOpen();
        // await setValue(result.data.blackOutModel.dateTime);
        await setBlackOutStarttime(result.data.blackOutModel);
        setHideSkeleton1(false);
      } else {
        // setOpen();
        setHideSkeleton1(false);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      // setOpen();
      setHideSkeleton1(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(() => {
    BlackOutGet();
  }, []);
  //  ..................................Blackout Update API..................................................//
  async function BlackOutUpdate(values) {
    // event.preventDefault()
    // setData([])
    try {
      setOpen(true);

      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/update/black-out`,
        {
          username: localStorage.getItem("usernamedisplayed"),
          id: blackOutStarttime.id,
          // tpsLimit: values.tpsLimit,
          startTime: moment(value)?.format("HH:mm"),
          endTime: moment(valueEnd)?.format("HH:mm"),

          //   pageSize: TableStatus?.pageSize,
        }
      );

      // console.log("result get api.........", result);

      if (result.data.statusDescription.statusCode == 200) {
        setOpen();
        // formik.handleReset();
        // values.tpsLimit = "";
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
        // await setData1(result.data.fileUploads);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  //   ---------------------------Blackout start calender-------------------------------------
  useEffect(() => {
    // const timeString = "06:04";

    // Get the current date
    const currentDate = moment();

    // Set the time of the current date
    const dateTime = moment(blackOutStarttime?.startTime, "HH:mm").set({
      year: currentDate.year(),
      month: currentDate.month(),
      date: currentDate.date(),
    });
    const dateTime1 = moment(blackOutStarttime?.endTime, "HH:mm").set({
      year: currentDate.year(),
      month: currentDate.month(),
      date: currentDate.date(),
    });
    // Convert the Date object to the desired format
    const formattedDate = dateTime.format(
      "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)"
    );
    const formattedDate1 = dateTime1.format(
      "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)"
    );
    // console.log("formattedDate--", formattedDate);
    setValue(formattedDate);
    setValueEnd(formattedDate1);
  }, [blackOutStarttime]);
  //   ........................................................................................................//
  const ResetState = () => {
    const currentDate = moment();

    // Set the time of the current date
    const dateTime = moment(blackOutStarttime?.startTime, "HH:mm").set({
      year: currentDate.year(),
      month: currentDate.month(),
      date: currentDate.date(),
    });
    const dateTime1 = moment(blackOutStarttime?.endTime, "HH:mm").set({
      year: currentDate.year(),
      month: currentDate.month(),
      date: currentDate.date(),
    });
    // Convert the Date object to the desired format
    const formattedDate = dateTime.format(
      "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)"
    );
    const formattedDate1 = dateTime1.format(
      "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)"
    );
    // console.log("formattedDate--", formattedDate);
    setValue(formattedDate);
    setValueEnd(formattedDate1);
  };
  // .........................................................................................//
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const modelButtonApprove1 = useRef(null);

  const approveUserModal1 = async (cell) => {
    // console.log(cell.row.original);

    await modelButtonApprove1.current.click();
    await setSelectedUserDetailApprove(cell.row.original);
  };
  const onKeyDown = (e) => {
    e.preventDefault();
  };
  // ..........................................................................................................//
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>

        {/* {selectedUserDetailApprove != undefined && ( */}
        <form
          //   onSubmit={formik.handleSubmit}
          className="row g-3 needs-validation"
          novalidate
        >
          <div>
            <button
              ref={modelButtonApprove1}
              type="button"
              className="btn btn-primary d-none"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop1"
            >
              Launch static backdrop modal
            </button>

            <div
              className="modal fade"
              id="staticBackdrop1"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdrop1Label"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdrop1Label">
                      Are you sure you want to update?
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        //   setSelectedUserDetailApprove(null);
                      }}
                    ></button>
                  </div>

                  <div className="modal-body"></div>

                  <div className="modal-footer justify-content-between">
                    <button
                      type="button"
                      id="close_edit1"
                      className="btn btn-secondary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        //   setSelectedUserDetailApprove(null);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        BlackOutUpdate();
                      }}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* )} */}

          <ThemeProvider theme={theme}>
            <div className="container-fluid">
              <div className="card">
                <div className="card-header p-3 pt-2">
                  <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
                    <PersonIcon
                      style={{
                        color: "white",
                        fontSize: "27px",
                      }}
                    />
                  </div>
                  <div className="pt-1">
                    <p
                      className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                      style={{ marginLeft: "70px" }}
                    >
                      Black Out Time
                    </p>
                    <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
                      Field(s) marked with{" "}
                      <span className="text-danger fw-bold">*</span> are
                      mandatory.
                    </p>
                  </div>
                </div>
                <div className="card-body mt-4">
                  <div className="card shadow-none border bg_blue">
                    <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                      Black Out Time
                    </span>

                    <div
                      className="card-body text-lg-start text-center "
                      id="ip_button"
                    >
                      <div className="row">
                        {hideSkeleton1 == true ? (
                          <>
                            <Box sx={{ width: "25%" }}>
                              <Skeleton />
                              <Skeleton animation="wave" />
                              {/* <Skeleton animation={false} /> */}
                            </Box>
                          </>
                        ) : (
                          <>
                            {" "}
                            <div className="col-md-3">
                              {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <TimePicker
                              label="Black out start time"
                              value={value}
                              onChange={(newValue) => {
                                setValue(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField required {...params} />
                              )}
                              ampm={false}
                            />
                          </LocalizationProvider> */}

                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                  className="pe-4"
                                  // className="clock_up"
                                  label="Start time"
                                  value={value}
                                  onChange={(newValue) => {
                                    // console.log("ne--", newValue);
                                    setValue(newValue?.$d);
                                  }}
                                  ampmInClock={true}
                                  renderInput={(params) => (
                                    <TextField
                                      value={value}
                                      size="small"
                                      required
                                      onKeyDown={onKeyDown}
                                      {...params}
                                    />
                                  )}
                                  ampm={false}
                                />
                              </LocalizationProvider>
                            </div>
                          </>
                        )}

                        {hideSkeleton1 == true ? (
                          <>
                            <Box sx={{ width: "25%" }}>
                              <Skeleton />
                              <Skeleton animation="wave" />
                              {/* <Skeleton animation={false} /> */}
                            </Box>
                          </>
                        ) : (
                          <>
                            {" "}
                            <div className="col-md-3">
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                  className="pe-4"
                                  label="End time"
                                  value={valueEnd}
                                  onChange={(newValue) => {
                                    setValueEnd(newValue?.$d);
                                  }}
                                  ampmInClock={true}
                                  renderInput={(params) => (
                                    <TextField
                                      value={valueEnd}
                                      size="small"
                                      required
                                      onKeyDown={onKeyDown}
                                      
                                      {...params}
                                    />
                                  )}
                                  ampm={false}
                                />
                              </LocalizationProvider>
                            </div>
                          </>
                        )}

                        <div className="col-md-3">
                          <button
                            type="button"
                            // disabled={
                            //   formik.values.tpsLimit == undefined  ||
                            //   formik.values.tpsLimit == ""

                            // }
                            className="btn green_UP btn_SIZE w_btn m-0 ms-3 btn_w8"
                            onClick={approveUserModal1}
                          >
                            Update
                            {/* <AddRoundedIcon style={{ fontSize: "19px" }} /> */}
                          </button>

                          <button
                            onClick={ResetState}
                            type="button"
                            className="btn resetBtn_UP m-0 ms-3 w_btn btn_w8 btnReset btn_SIZE"
                            // onClick={Reset}
                            //   onClick={() => {
                            //     formik.resetForm();
                            //     seterror(false);
                            //     setUserState([]);
                            //     setValue(null)

                            //   }}
                          >
                            Reset
                            {/* <SettingsBackupRestoreRoundedIcon
                            style={{ fontSize: "17px" }}
                          />{" "} */}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ThemeProvider>
        </form>
      </main>
    </>
  );
};

export default BlackOut;










// import {
//   Backdrop,
//   FormControl,
//   IconButton,
//   InputAdornment,
//   InputLabel,
//   MenuItem,
//   Select,
//   TextField,
//   ThemeProvider,
//   Tooltip,
// } from "@mui/material";
// import React, { useEffect, useState, useMemo, useRef } from "react";
// import { Link, useHistory } from "react-router-dom";
// import { useFormik } from "formik";
// import * as yup from "yup";
// // import AccessLevel from "./AccessLevel";
// import { createTheme } from "@mui/material/styles";
// import { common_axios } from "../../../App";
// import Loader from "../../../components/Loader";
// import PersonIcon from "@mui/icons-material/Person";
// import InfoIcon from "@mui/icons-material/Info";
// import Swal from "sweetalert2";
// import Box from "@mui/material/Box";
// import Skeleton from "@mui/material/Skeleton";
// import AdapterDateFns from "@mui/lab/AdapterDateFns";
// // import LocalizationProvider from "@mui/lab/LocalizationProvider";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import moment from "moment";
// // import { TimePicker } from "@mui/lab";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { TimePicker } from "@mui/x-date-pickers";
// import OtpTimer from "otp-timer";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// const BlackOut = () => {
//   const theme = createTheme({
//     components: {
//       MuiInputLabel: {
//         styleOverrides: {
//           asterisk: {
//             color: "red",
//           },
//         },
//       },
//     },
//   });
//   const [open, setOpen] = useState();
//   const [value, setValue] = React.useState(new Date());
//   const [valueEnd, setValueEnd] = React.useState(new Date());
//   const [time, setTime] = React.useState();
//   const [blackOutStarttime, setBlackOutStarttime] = React.useState();
//   const [hideSkeleton1, setHideSkeleton1] = useState();

//   // console.log("va--", blackOutStarttime);
//   const handleChange = (event) => {
//     setValue(event.target.value);
//     const date1 = moment(value).format("HH:mm:ss");
//   };
//   // console.log("val", value);
//   const date1 = moment(value).format("HH:mm:ss");

//   // console.log("ths", date1);
//   //  .................................BlackOut Get API..................................................//

//   async function BlackOutGet() {
//     // setData([])
//     setHideSkeleton1(true);

//     try {
//       // setOpen(true);

//       const result = await common_axios.get(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/get/black-out`
//       );

//       // console.log("result get api.........", result);

//       if (result.data.statusDescription.statusCode == 200) {
//         setOpen();
//         // await setValue(result.data.blackOutModel.dateTime);
//         await setBlackOutStarttime(result.data.blackOutModel);
//         setHideSkeleton1(false);
//       } else {
//         // setOpen();
//         setHideSkeleton1(false);

//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusdescription,
//         });
//       }
//     } catch (error) {
//       // setOpen();
//       setHideSkeleton1(false);

//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   }
//   useEffect(() => {
//     BlackOutGet();
//   }, []);
//   //  ..................................Blackout Update API..................................................//
//   async function BlackOutUpdate(values) {
//     // event.preventDefault()
//     // setData([])
//     try {
//       setOpen(true);

//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_SENDER_ID}/admin/v1/update/black-out`,
//         {
//           username: localStorage.getItem("usernamedisplayed"),
//           id: blackOutStarttime.id,
//           // tpsLimit: values.tpsLimit,
//           startTime: moment(value)?.format("HH:mm"),
//           endTime: moment(valueEnd)?.format("HH:mm"),

//           //   pageSize: TableStatus?.pageSize,
//         }
//       );

//       // console.log("result get api.........", result);

//       if (result.data.statusDescription.statusCode == 200) {
//         setOpen();
//         // formik.handleReset();
//         // values.tpsLimit = "";
//         Swal.fire({
//           icon: "success",
//           // title: "Oops...",
//           text: result.data.statusDescription.statusdescription,
//         });
//         // await setData1(result.data.fileUploads);
//       } else {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusDescription.statusdescription,
//         });
//       }
//     } catch (error) {
//       setOpen(false);

//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: "Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   }

//   //   ---------------------------Blackout start calender-------------------------------------
//   useEffect(() => {
//     // const timeString = "06:04";

//     // Get the current date
//     const currentDate = moment();

//     // Set the time of the current date
//     const dateTime = moment(blackOutStarttime?.startTime, "HH:mm").set({
//       year: currentDate.year(),
//       month: currentDate.month(),
//       date: currentDate.date(),
//     });
//     const dateTime1 = moment(blackOutStarttime?.endTime, "HH:mm").set({
//       year: currentDate.year(),
//       month: currentDate.month(),
//       date: currentDate.date(),
//     });
//     // Convert the Date object to the desired format
//     const formattedDate = dateTime.format(
//       "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)"
//     );
//     const formattedDate1 = dateTime1.format(
//       "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)"
//     );
//     // console.log("formattedDate--", formattedDate);
//     setValue(formattedDate);
//     setValueEnd(formattedDate1);
//   }, [blackOutStarttime]);
//   //   ........................................................................................................//
//   const ResetState = () => {
//     const currentDate = moment();

//     // Set the time of the current date
//     const dateTime = moment(blackOutStarttime?.startTime, "HH:mm").set({
//       year: currentDate.year(),
//       month: currentDate.month(),
//       date: currentDate.date(),
//     });
//     const dateTime1 = moment(blackOutStarttime?.endTime, "HH:mm").set({
//       year: currentDate.year(),
//       month: currentDate.month(),
//       date: currentDate.date(),
//     });
//     // Convert the Date object to the desired format
//     const formattedDate = dateTime.format(
//       "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)"
//     );
//     const formattedDate1 = dateTime1.format(
//       "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)"
//     );
//     // console.log("formattedDate--", formattedDate);
//     setValue(formattedDate);
//     setValueEnd(formattedDate1);
//   };
//   // .........................................................................................//
//   const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
//     useState(undefined);
//   const modelButtonApprove1 = useRef(null);

//   const approveUserModal1 = async (cell) => {
//     // console.log(cell.row.original);

//     await modelButtonApprove1.current.click();
//     await setSelectedUserDetailApprove(cell.row.original);
//   };
//   const onKeyDown = (e) => {
//     e.preventDefault();
//   };


// // ...............................Otp Verification............................................//


// const [part1, setPart1] = useState("");
// const [part2, setPart2] = useState("");
// const [part3, setPart3] = useState("");
// const [part4, setPart4] = useState("");
// const [part5, setPart5] = useState("");
// const [part6, setPart6] = useState("");
// const [showPasswordGeneratePin, setshowPasswordGeneratePin] = useState("");

// const inputRef1 = useRef(null);
// const inputRef2 = useRef(null);  
// const inputRef3 = useRef(null);
// const inputRef4 = useRef(null);
// const inputRef5 = useRef(null);
// const inputRef6 = useRef(null);
// // console.log("oip", Ip);
// const handleInputChange = (event) => {
//   const value = event.target.value;
//   if (value >= 0 && value <= 9) {
//     setPart1(value);
//   }
// };
// const handleInputChange2 = (event) => {
//   const value = event.target.value;
//   if (value >= 0 && value <= 9) {
//     setPart2(value);
//   }
// };
// const handleInputChange3 = (event) => {
//   const value = event.target.value;
//   if (value >= 0 && value <= 9) {
//     setPart3(value);
//   }
// };
// const handleInputChange4 = (event) => {
//   const value = event.target.value;
//   if (value >= 0 && value <= 9) {
//     setPart4(value);
//   }
// };
// const handleInputChange5 = (event) => {
//   const value = event.target.value;
//   if (value >= 0 && value <= 9) {
//     setPart5(value);
//   }
// };

// const handleInputChange6 = (event) => {
//   const value = event.target.value;
//   if (value >= 0 && value <= 9) {
//     setPart6(value);
//   }
// };

// useEffect(() => {
//   if (part1.length == 1) {
//     inputRef2.current.focus();
//   }
// }, [part1]);

// useEffect(() => {
//   if (part2.length == 1) {
//     inputRef3.current.focus();
//   }
// }, [part2]);

// useEffect(() => {
//   if (part3.length == 1) {
//     inputRef4.current.focus();
//   }
// }, [part3]);
// useEffect(() => {
//   if (part4.length == 1) {
//     inputRef5.current.focus();
//   }
// }, [part4]);
// useEffect(() => {
//   if (part5.length == 1) {
//     inputRef6.current.focus();
//   }
// }, [part5]);
// useEffect(() => {
//   if (part6.length == 1) {
//     inputRef6.current.focus();
//   }
// }, [part6]);

// const handleKeyDown1 = (event) => {
//   // console.log("mkk", event.key);
//   if (event.key === "Backspace") {
//     event.preventDefault();
//     setPart6("");
//     inputRef5.current.focus();
//   }
// };
// const handleKeyDown2 = (event) => {
//   // console.log("mkk", event.key);
//   if (event.key === "Backspace") {
//     event.preventDefault();
//     setPart2("");
//     inputRef1.current.focus();
//   }
// };
// const handleKeyDown3 = (event) => {
//   // console.log("mkk", event.key);
//   if (event.key === "Backspace") {
//     event.preventDefault();
//     setPart3("");
//     inputRef2.current.focus();
//   }
// };
// const handleKeyDown4 = (event) => {
//   // console.log("mkk", event.key);
//   if (event.key === "Backspace") {
//     event.preventDefault();
//     setPart4("");
//     inputRef3.current.focus();
//   }
// };
// const handleKeyDown5 = (event) => {
//   // console.log("mkk", event.key);
//   if (event.key === "Backspace") {
//     event.preventDefault();
//     setPart5("");
//     inputRef4.current.focus();
//   }
// };

// const handleKeyDown6 = (event) => {
//   // console.log("mkk", event.key);
//   if (event.key === "Backspace") {
//     event.preventDefault();
//     setPart6("");
//     inputRef5.current.focus();
//   }
// };

// const handleClickShowPasswordGeneratePin = () =>
// setshowPasswordGeneratePin(!showPasswordGeneratePin);


//  // ----------------------------Otp timer----------------------------------------
//  const INITIAL_COUNT = 120;

//  const [secondsRemaining, setSecondsRemaining] = useState(INITIAL_COUNT);
//  const handleStart = () => {
//    setStatus(STATUS.STARTED);
//    setSecondsRemaining(INITIAL_COUNT);
//  };

//  const STATUS = {
//    STARTED: "Started",
//    //   STOPPED:<b>
//    //     <a type="button" class="text-danger" onCLick={handleStart}>
//    // Resend ot
//    //     </a>
//    //   </b>
//  };
//  const [status, setStatus] = useState(STATUS.STOPPED);
//  // console.log("d897", formik.handleReset);
//  const secondsToDisplay = secondsRemaining % 60;
//  const minutesRemaining = (secondsRemaining - secondsToDisplay) / 60;
//  const minutesToDisplay = minutesRemaining % 60;

//  useInterval(
//    () => {
//      if (secondsRemaining > 0) {
//        setSecondsRemaining(secondsRemaining - 1);
//      } else {
//        setStatus(STATUS.STOPPED);
//      }
//    },
//    status === STATUS.STARTED ? 1000 : null
//    // passing null stops the interval
//  );

//  function useInterval(callback, delay) {
//    const savedCallback = useRef();

//    // Remember the latest callback.
//    useEffect(() => {
//      savedCallback.current = callback;
//    }, [callback]);

//    // Set up the interval.
//    useEffect(() => {
//      function tick() {
//        savedCallback.current();
//      }
//      if (delay !== null) {
//        let id = setInterval(tick, delay);
//        return () => clearInterval(id);
//      }
//    }, [delay]);
//  }

//  const twoDigits = (num) => String(num).padStart(2, "0");

//  // console.log("dhu", Services);

//  const funMobilerecharge = async () => {
//    // alert("sj");
//  };

//   // ..........................................................................................................//
//   return (
//     <>
//       <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
//         <Backdrop
//           sx={{
//             transform: "translateZ(0)",
//             color: "#fff",
//             zIndex: (theme) => theme.zIndex.drawer + 1,
//           }}
//           open={open}
//           // onClick={handleClose}
//         >
//           <Loader />
//         </Backdrop>

//         {/* {selectedUserDetailApprove != undefined && ( */}
//         <form
//           //   onSubmit={formik.handleSubmit}
//           className="row g-3 needs-validation"
//           novalidate
//         >
//           <div>
//             <button
//               ref={modelButtonApprove1}
//               type="button"
//               className="btn btn-primary d-none"
//               data-bs-toggle="modal"
//               data-bs-target="#staticBackdrop1"
//             >
//               Launch static backdrop modal
//             </button>

//             <div
//               className="modal fade"
//               id="staticBackdrop1"
//               data-bs-backdrop="static"
//               data-bs-keyboard="false"
//               tabindex="-1"
//               aria-labelledby="staticBackdrop1Label"
//               aria-hidden="true"
//             >
//               <div className="modal-dialog">
//                 <div className="modal-content">
//                   <div className="modal-header">
//                     <h5 className="modal-title" id="staticBackdrop1Label">
//                       Are you sure you want to update?
//                     </h5>
//                     <button
//                       type="button"
//                       className="btn-close"
//                       data-bs-dismiss="modal"
//                       aria-label="Close"
//                       onClick={() => {
//                         //   setSelectedUserDetailApprove(null);
//                       }}
//                     ></button>
//                   </div>

//                   <div className="modal-body">
//                   <div
//                       class="input-group input-group-outline input_field mx-auto"
//                       style={{ width: "100%", background: "none" }}
//                     >

// <img
//                   className="mx-auto"
//                   // src={mobileopt}
//                   alt="error"
//                   style={{ width: "43%" }}
//                 />
//                 <div className="App">
//                   {status == STATUS?.STARTED ? (
//                     <>
//                       <div>

//                         <b className="text-success">Resend OTP in</b>
//                         <b className="ml-2 text-danger">
                        
//                           {" " + twoDigits(minutesToDisplay)}:

//                           {twoDigits(secondsToDisplay)}

//                         </b>
//                       </div>
//                     </>
//                   ) : (
//                     <>
//                       <a
//                         onClick={() => {
//                           // ResendOTP();
//                           handleStart();
//                         }}
//                         //   type="button"
//                         style={{
//                           color: "#4caf50",
//                           fontWeight: "700",
//                           cursor: "pointer",
//                         }}
//                         id="resendotp"
//                       >
//                         Resend OTP
//                       </a>
//                     </>
//                   )}
//                 </div>
//              <div class="my-4">
//                 <div
//                   class="input-group input-group-outline input_field mx-auto"
//                   style={{ width: "100%", background: "none" }}
//                 >

//                   <div className="row alignDivnew">
//                     <div className="col d-flex align-items-center">
//                       {/* <input
//                         placeholder="*"
//                         // type="number"
//                         id="part1UP"
//                         className="impMargin1 otp_Input"
//                         required
//                         type={showPasswordUpdateold ? "text" : "password"}
//                         // min={0}
//                         // max={9}
//                         maxLength={1}
//                         ref={inputRef1Confirm}
//                         value={part1}
//                         onChange={(event) =>
//                           handleInputChange(event, setPart1)
//                         }
//                         onKeyPress={(event) => {
//                           const keyCode = event.keyCode || event.which;

//                           if (keyCode >= 48 && keyCode <= 57) {
//                             setPart1("");
//                           }
//                         }}
//                       /> */}

// <input
//                                         // type="number"
//                                         placeholder="*"

//                                         id="part1UP"
//                                         className="impMargin1 otp_Input"
//                                         required
//                                         type={showPasswordGeneratePin ? "text" : "password"}

//                                         // min={0}
//                                         // max={9}
//                                         maxLength={1}
//                                         ref={inputRef1}
//                                         value={part1}
//                                         onChange={(event) =>
//                                           handleInputChange(event, setPart1)
//                                         }
//                                         onKeyPress={(event) => {
//                                           const keyCode =
//                                             event.keyCode || event.which;

//                                           if (keyCode >= 48 && keyCode <= 57) {
//                                             setPart1("");
//                                           }
//                                         }}
//                                       />



//                     </div>

//                     <div className="col d-flex align-items-center">


//                     <input
//                             placeholder="*"
//                             // type="number"
//                             type={showPasswordGeneratePin ? "text" : "password"}
//                             id="part2"
//                             className="impMargin2 otp_Input"
//                             required
//                             // min={0}
//                             // max={9}
//                             maxLength={1}
//                             value={part2}
//                             ref={inputRef2}
//                             onChange={(event) =>
//                               handleInputChange2(event, setPart2)
//                             }
//                             onKeyDown={handleKeyDown2}
//                             onKeyPress={(event) => {
//                               const keyCode = event.keyCode || event.which;

//                               if (keyCode >= 48 && keyCode <= 57) {
//                                 setPart2("");
//                               }
//                             }}
//                           />
                     
//                     </div>

//                     <div className="col d-flex align-items-center">
//                     <input
//                             placeholder="*"
//                             // type="number"
//                             type={showPasswordGeneratePin ? "text" : "password"}
//                             id="part3"
//                             className="impMargin2 otp_Input"
//                             required
//                             // min={0}
//                             // max={9}
//                             maxLength={1}
//                             value={part3}
//                             ref={inputRef3}
                            
//                             onChange={(event) =>
//                               handleInputChange3(event, setPart3)
//                             }
//                             onKeyDown={handleKeyDown3}
//                             onKeyPress={(event) => {
//                               const keyCode = event.keyCode || event.which;

//                               if (keyCode >= 48 && keyCode <= 57) {
//                                 setPart3("");
//                               }
//                             }}
//                           />
//                     </div>

//                     <div className="col d-flex align-items-center">
//                     <input
//                             placeholder="*"
//                             type={showPasswordGeneratePin ? "text" : "password"}
//                             id="part4"
//                             className="impMargin2 otp_Input"
//                             required
//                             // min={0}
//                             // max={9}
//                             maxLength={1}
//                             value={part4}
//                             ref={inputRef4}
//                             onChange={(event) =>
//                               handleInputChange4(event, setPart4)
//                             }
//                             onKeyDown={handleKeyDown4}
//                             onKeyPress={(event) => {
//                               const keyCode = event.keyCode || event.which;

//                               if (keyCode >= 48 && keyCode <= 57) {
//                                 setPart4("");
//                               }
//                             }}
//                           />
//                     </div>
//                     <div className="col d-flex align-items-center">
//                     <IconButton
//                             aria-label="toggle password visibility"
//                             onClick={handleClickShowPasswordGeneratePin}
//                             // onMouseDown={handleMouseDownPassword}
//                             style={{
//                               backgroundColor: "rgb(232 240 254 / 26%)",
//                               borderRadius: "0 0.375rem 0.375rem 0",
//                             }}
//                           >
//                             {showPasswordGeneratePin ? (
//                               <VisibilityIcon sx={{ color: "#1990d0" }} />
//                             ) : (
//                               <VisibilityOffIcon sx={{ color: "#1990d0" }} />
//                             )}
//                           </IconButton>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//                     </div>


//                   </div>

//                   <div className="modal-footer justify-content-between">
//                     {/* <button
//                       type="button"
//                       id="close_edit1"
//                       className="btn btn-secondary"
//                       data-bs-dismiss="modal"
//                       onClick={() => {
//                         //   setSelectedUserDetailApprove(null);
//                       }}
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       type="button"
//                       className="btn btn-primary"
//                       data-bs-dismiss="modal"
//                       onClick={() => {
//                         BlackOutUpdate();
//                       }}
//                     >
//                       Confirm
//                     </button> */}
//                     <button
//                                     type="button"
//                                     className="btn bg-gradient-secondary m-0 w_btn btn_w8 btnReset btn_design1"
//                                     // onClick={() => {
//                                     //   setOtpVerify();
//                                     //   localStorage.removeItem("transactionId");
//                                     //   setPart1("");
//                                     //   setPart2("");
//                                     //   setPart3("");
//                                     //   setPart4("");
//                                     //   setPart5("");
//                                     //   setPart6("");
//                                     // }}
//                                   >
//                                     Back
                                  
//                                   </button>
//                                   <button
//                                     disabled={
//                                       part1 === "" ||
//                                       part2 === "" ||
//                                       part3 === "" ||
//                                       part4 === ""
//                                     }
//                                     type="submit"
//                                     className="btn w_btn m-0 btn_w8 btn_design2"
//                                     style={{
//                                       backgroundImage:
//                                         " linear-gradient(195deg,#004872,#008cb6)",
//                                       fontSize: "14px",
//                                     }}
//                                   >
//                                     Confirm Otp
//                                   </button>
//                   </div>

                 
//                 </div>
//               </div>
//             </div>
//           </div>
//           {/* )} */}

//           <ThemeProvider theme={theme}>
//             <div className="container-fluid">
//               <div className="card">
//                 <div className="card-header p-3 pt-2">
//                   <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
//                     <PersonIcon
//                       style={{
//                         color: "white",
//                         fontSize: "27px",
//                       }}
//                     />
//                   </div>
//                   <div className="pt-1">
//                     <p
//                       className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
//                       style={{ marginLeft: "70px" }}
//                     >
//                       Black Out Time
//                     </p>
//                     <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
//                       Field(s) marked with{" "}
//                       <span className="text-danger fw-bold">*</span> are
//                       mandatory.
//                     </p>
//                   </div>
//                 </div>
//                 <div className="card-body mt-4">
//                   <div className="card shadow-none border bg_blue">
//                     <span className="badge rounded-pill bg-primary mt-n3 ms-5">
//                       Black Out Time
//                     </span>

//                     <div
//                       className="card-body text-lg-start text-center "
//                       id="ip_button"
//                     >
//                       <div className="row">
//                         {hideSkeleton1 == true ? (
//                           <>
//                             <Box sx={{ width: "25%" }}>
//                               <Skeleton />
//                               <Skeleton animation="wave" />
//                               {/* <Skeleton animation={false} /> */}
//                             </Box>
//                           </>
//                         ) : (
//                           <>
//                             {" "}
//                             <div className="col-md-3">
//                               {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
//                             <TimePicker
//                               label="Black out start time"
//                               value={value}
//                               onChange={(newValue) => {
//                                 setValue(newValue);
//                               }}
//                               renderInput={(params) => (
//                                 <TextField required {...params} />
//                               )}
//                               ampm={false}
//                             />
//                           </LocalizationProvider> */}

//                               <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                 <TimePicker
//                                   className="pe-4"
//                                   // className="clock_up"
//                                   label="Start time"
//                                   value={value}
//                                   onChange={(newValue) => {
//                                     // console.log("ne--", newValue);
//                                     setValue(newValue?.$d);
//                                   }}
//                                   ampmInClock={true}
//                                   renderInput={(params) => (
//                                     <TextField
//                                       value={value}
//                                       size="small"
//                                       required
//                                       onKeyDown={onKeyDown}
//                                       {...params}
//                                     />
//                                   )}
//                                   ampm={false}
//                                 />
//                               </LocalizationProvider>
//                             </div>
//                           </>
//                         )}

//                         {hideSkeleton1 == true ? (
//                           <>
//                             <Box sx={{ width: "25%" }}>
//                               <Skeleton />
//                               <Skeleton animation="wave" />
//                               {/* <Skeleton animation={false} /> */}
//                             </Box>
//                           </>
//                         ) : (
//                           <>
//                             {" "}
//                             <div className="col-md-3">
//                               <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                 <TimePicker
//                                   className="pe-4"
//                                   label="End time"
//                                   value={valueEnd}
//                                   onChange={(newValue) => {
//                                     setValueEnd(newValue?.$d);
//                                   }}
//                                   ampmInClock={true}
//                                   renderInput={(params) => (
//                                     <TextField
//                                       value={valueEnd}
//                                       size="small"
//                                       required
//                                       onKeyDown={onKeyDown}
                                      
//                                       {...params}
//                                     />
//                                   )}
//                                   ampm={false}
//                                 />
//                               </LocalizationProvider>
//                             </div>
//                           </>
//                         )}

//                         <div className="col-md-3">
//                           <button
//                             type="button"
//                             // disabled={
//                             //   formik.values.tpsLimit == undefined  ||
//                             //   formik.values.tpsLimit == ""

//                             // }
//                             className="btn green_UP btn_SIZE w_btn m-0 ms-3 btn_w8"
//                             onClick={approveUserModal1}
//                           >
//                             Update
//                             {/* <AddRoundedIcon style={{ fontSize: "19px" }} /> */}
//                           </button>

//                           <button
//                             onClick={ResetState}
//                             type="button"
//                             className="btn resetBtn_UP m-0 ms-3 w_btn btn_w8 btnReset btn_SIZE"
//                             // onClick={Reset}
//                             //   onClick={() => {
//                             //     formik.resetForm();
//                             //     seterror(false);
//                             //     setUserState([]);
//                             //     setValue(null)

//                             //   }}
//                           >
//                             Reset
//                             {/* <SettingsBackupRestoreRoundedIcon
//                             style={{ fontSize: "17px" }}
//                           />{" "} */}
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </ThemeProvider>
//         </form>
//       </main>
//     </>
//   );
// };

// export default BlackOut;
